import { useEffect, useState } from "react";
import { connect } from "react-redux";

// @material-ui/core components
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Pagination from "@material-ui/lab/Pagination";
import { getOpportunityUsersAction } from "redux/actions/opportunitiesAction";
import { ArrayUtils } from "utils/array_utils";
import { DATASET, OPPORTUNITY_STATE_KEY, PAGINATION } from "utils/const";

//custom components
import componentStylesGeneric from "assets/theme/views/admin/generic";
import componentStyles from "assets/theme/views/admin/generic-page-table-result.js";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import AddCandidates from "../Modals/AddCandidatesModal.js";
import CandidatesListSection from "../Sections/CandidatesListSection";

const useStylesGeneric = makeStyles(componentStylesGeneric);
const useStyles = makeStyles(componentStyles);

const useStylesLocal = makeStyles((theme) => ({
  containerNoGuttersMobile: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

function OpportunityCandidatesTab(props) {
  const classes = { ...useStylesGeneric(), ...useStyles() };
  const classesLocal = useStylesLocal();
  const [opportunityType, setOpportunityType] = useState();

  const [pageIndex, setPageIndex] = useState(PAGINATION.FIRST_PAGE);
  const [showAddCandidatesModal, setShowAddCandidatesModal] = useState(false);

  const handleChangePage = (event, value) => {
    setPageIndex(value);
  };

  useEffect(() => {
    refreshResults(pageIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);

  const refreshResults = (nextPageIndex) => {
    let filter = {
      opportunityId: props.opportunityId,
      pageIndex: nextPageIndex,
      pageSize: PAGINATION.PAGE_SIZE,
    };
    props.getOpportunityUsers(filter);
  };

  const handleSuccessAddCandidates = () => {
    setPageIndex(PAGINATION.FIRST_PAGE);
    refreshResults(PAGINATION.FIRST_PAGE);
  };

  useEffect(() => {
    if (!ArrayUtils.NullOrEmpty(props.opportunitiesState.opportunityDetailsData?.opportunityCandidates)) {
      setOpportunityType(props.opportunitiesState.opportunityDetailsData?.opportunityTypeKey);
    } else {
      setOpportunityType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opportunitiesState.opportunityDetailsData?.opportunityCandidates]);

  useEffect(() => {
    if (props.datasetsState[DATASET.PROVINCES] === undefined || props.datasetsState[DATASET.PROVINCES]?.length === 0) {
      props.getDataSetByName(DATASET.PROVINCES);
    }

    if (
      props.datasetsState[DATASET.PROFESSIONAL_CATEGORY] === undefined ||
      props.datasetsState[DATASET.PROFESSIONAL_CATEGORY]?.length === 0
    ) {
      props.getDataSetByName(DATASET.PROFESSIONAL_CATEGORY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenAddCandidatesModal = () => {
    setShowAddCandidatesModal(true);
  };

  const handleCloseAddCandidatesModal = () => {
    setShowAddCandidatesModal(false);
  };

  return (
    <Container maxWidth={false} className={classesLocal.containerNoGuttersMobile} component={Box} marginTop="0">
      <CardTableContainer
        title={"Candidatos"}
        count={props.opportunitiesState?.total_records}
        responsiveHeader={true}
        actionButtonSize={"medium"}
        actionButtonLabel={
          props.opportunitiesState.opportunityDetailsData?.opportunityStateKey === OPPORTUNITY_STATE_KEY.APROVADA &&
          "Adicionar Candidatos"
        }
        actionButtonOnClick={
          props.opportunitiesState.opportunityDetailsData?.opportunityStateKey === OPPORTUNITY_STATE_KEY.APROVADA &&
          handleOpenAddCandidatesModal
        }
      >
        <CandidatesListSection opportunityId={props.opportunityId} opportunityType={opportunityType} />
        <Pagination
          className={classes.align}
          count={props.opportunitiesState?.total_pages}
          page={pageIndex}
          onChange={handleChangePage}
          color="primary"
          style={{ margin: "20px 0" }}
        ></Pagination>
      </CardTableContainer>

      {/* Add Candidates Modal */}
      <GenericDialog maxWidth={"xl"} open={showAddCandidatesModal} onClose={handleCloseAddCandidatesModal}>
        <AddCandidates
          opportunityDetailsData={props.opportunityDetailsData}
          handleClose={handleCloseAddCandidatesModal}
          onSuccess={handleSuccessAddCandidates}
        />
      </GenericDialog>
    </Container>
  );
}
const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getOpportunityUsers: (formData) => dispatch(getOpportunityUsersAction(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityCandidatesTab);
